import { CodeGenerationContextProvider } from '@common/git/CodeGeneration/context';
import { ProjectContextProvider } from '@common/git/Project/context';
import { useIdeActions, useIdeState } from '@common/ide/state';
import { LogMessageProvider } from '@common/LogMessageContext';
import { QueryKeys } from '@common/queries/common';
import { ProjectDetail, projectDetailQuery } from '@common/queries/project';
import { Centered, Spinner } from '@prophecy/ui-v3';
import { useEffect } from 'react';

import { ExecutionServiceProvider } from '../../context/execution';
import { useExecutionServiceInstance } from '../../data/executionHooks';
import { useGraphQlQuery } from '../../data/util';
import { ComponentRunContext, useRunDataContext } from '../Workflow/AttachFabric/componentRunhook';
import { EmptyProject } from './EmptyProject';
import { Lineage } from './Lineage';

export default function ProjectLineage({ projectId }: { projectId: string }) {
  const branch = useIdeState((state) => state.ide.branch);
  const { data, isLoading } = useGraphQlQuery(
    [QueryKeys.Git, QueryKeys.Project, 'project-detail', { projectId }],
    projectDetailQuery,
    undefined,
    {
      projectId,
      branch: branch
    }
  );
  const ideActions = useIdeActions();

  useEffect(() => {
    ideActions.setReadOnly(false);
  }, [ideActions]);

  //NOTE: Attach fabric is not needed on project lineage, this is just to have design consistency
  const executionService = useExecutionServiceInstance();
  const runData = useRunDataContext();

  if (isLoading) {
    return (
      <Centered>
        <Spinner />
      </Centered>
    );
  }
  const project = data?.Project;
  if (!project) {
    return null;
  }

  return (
    <ProjectContextProvider projectId={projectId}>
      <ExecutionServiceProvider value={executionService}>
        <ComponentRunContext.Provider value={runData}>
          <CodeGenerationContextProvider>
            <LogMessageProvider>
              {project.pipelinesCount ? (
                <Lineage project={project as ProjectDetail} />
              ) : (
                <EmptyProject project={project as ProjectDetail} />
              )}
            </LogMessageProvider>
          </CodeGenerationContextProvider>
        </ComponentRunContext.Provider>
      </ExecutionServiceProvider>
    </ProjectContextProvider>
  );
}
